export const DUPLICATE_NAME_ERROR = 'Client with first name, middle name, last name already exists';
